import React, { useState, useEffect } from 'react';
import TablaAvanceDiarioActividad from './microcomponentes/TablaAvanceDiarioActividad';
import AjustarMetasDeActividad from './microcomponentes/AjustarMetasDeActividad';
import { set } from 'lodash';

const DetallesActividadGuardada = (p) => {
    const historial = p.historial ?? false; //determina si se esta en modo hisorial para no permitir el registro de actividades
    const data = p.data;
    const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const [ajustar, setajustar] = useState(null);

    const ajustarActividad = () => {
        if (ajustar || historial) return;
        setajustar(data);
    }

    const cerrar_edicion = () => setajustar(null);
    return (
        <div className='w-100 mb-3 border border-3 bg-white text-center p-0 round-bottom-l shadow relative'>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 mb-2 text-m text-bold'>
                    Detalles de actividad
                    <span className='text-400 ms-2'>{data.labor}</span>
                    <div className='w-100 m-0 mb-2 mt-2 '>
                        <div className='row justify-content-evenly w-100 m-0 p-0'>
                            <div className='col-auto ps-2 pe-2 border-bottom border-2 text-sm text-bold round-m'>
                                Semana siembra <span className='text-m text-300 ms-2'>{data.semana_siembra}</span>
                            </div>
                            <div className='col-auto ps-2 pe-2 border-bottom border-2 text-s text-bold round-m'>
                                Semana trasplante <span className='text-m text-300 ms-2'>{data.semana_trasplante}</span>
                            </div>
                            <div className='col-auto ps-2 pe-2 border-bottom border-2 text-s text-bold round-m'>
                                Semana cosecha <span className='text-m text-300 ms-2'>{data.semana_cosecha}</span>
                            </div>
                        </div>
                    </div>
                    {!historial && <div className='col-auto m-2' style={{ position: "absolute", top: 0, right: 0, zIndex: 2 }}>
                        <button className='btn btn-warning shadow border border text-bold btn-sm scale-025' onClick={ajustarActividad} >Editar planeación</button>
                    </div>}
                    <TablaAvanceDiarioActividad data={data} registrar={p.registrar} historial={historial} cerrarPadre={p.cerrarPadre} />
                    {ajustar && <AjustarMetasDeActividad data={ajustar} close={cerrar_edicion} editar={p.editar} cerrarPadre={p.cerrarPadre} />}
                </div>
            </div>
        </div>
    )
}

export default DetallesActividadGuardada;